import { createSlice } from "@reduxjs/toolkit";
import {
  blockUser,
  clearUserSystemAddress,
  currentUserDetails,
  getAllUsers,
  getUserCountStatics,
  updateUser,
} from "../actions/user";

export const usersSlice = createSlice({
  name: "users",
  initialState: {
    loading: false,
    usersList: [],
    currentUser: null,
    totalCount: 0,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      //login user
      .addCase(getAllUsers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllUsers.fulfilled, (state, action) => {
        state.loading = false;
        const { result, totalDocument } = action.payload;

        state.usersList = result;
        state.totalCount = totalDocument;
      })
      .addCase(getAllUsers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload; // The error message from `rejectWithValue`
      })
      //currentUserDetails
      .addCase(currentUserDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(currentUserDetails.fulfilled, (state, action) => {
        state.loading = false;
        const { user } = action.payload;

        state.currentUser = user;
      })
      .addCase(currentUserDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload; // The error message from `rejectWithValue`
      })
      //updateUser
      .addCase(updateUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateUser.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload; // The error message from `rejectWithValue`
      })
      //clearUserSystemAddress
      .addCase(clearUserSystemAddress.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(clearUserSystemAddress.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(clearUserSystemAddress.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload; // The error message from `rejectWithValue`
      })
      //getUserCountStatics
      .addCase(getUserCountStatics.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getUserCountStatics.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(getUserCountStatics.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload; // The error message from `rejectWithValue`
      })
      //blockUser
      .addCase(blockUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(blockUser.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(blockUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload; // The error message from `rejectWithValue`
      });
  },
});

export default usersSlice.reducer;
